import * as React from 'react';
import {CTA, ExternalLinkIndicator} from '@volkswagen-onehub/components-core';
import {LinkProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function Link(props: LinkProps): JSX.Element {
  const {
    children,
    icon,
    iconPosition,
    ariaLabel,
    tabIndex,
    href,
    target,
    rel,
    title,
  } = props;
  return (
    <CTA
      icon={icon}
      iconPosition={iconPosition}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      href={href}
      target={target}
      rel={rel}
      title={title}
      tag="a"
      emphasis="tertiary"
    >
      {children}
      {props.external && <ExternalLinkIndicator />}
    </CTA>
  );
}
